export default __webpack_public_path__ + "images/88c0ee1a68bc683fe2ecb970238f1375-diners@2x.png";